module.exports = __webpack_public_path__ + "static/media/meet-the-nutricia-resource-centre.a201acad.pdf";